
import Header from './components/Header';
import Hero from './components/Hero';
import Equipment from './components/Equipment';
import Specifications from './components/Specifications';
import Applications from './components/Applications';
import Supplier from './components/Supplier';
import Documentation from './components/Documentation';
import SelectionForm from './components/SelectionForm';
import Footer from './components/Footer';
import MobileActionButtons from '../../components/feature/MobileActionButtons';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Equipment />
        <Specifications />
        <Applications />
        <Supplier />
        <Documentation />
        <SelectionForm />
      </main>
      <Footer />
      <MobileActionButtons />
    </div>
  );
}
